import MatchList from '../components/Matches/MatchList';

const styles = {
  container: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
};

export default function MatchesPage() {
  return (
    <div style={styles.container}>
      <MatchList />
    </div>
  );
}
